import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-zcams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-zcams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationZcConstants } from "./create-application-location-zc.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AlertType } from "../../../../shared/models/alert";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { debounceTime } from "rxjs";
import Polygon from "@arcgis/core/geometry/Polygon";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { CreateApplicationLocationEcConstants } from "../../ec/create-application-location-ec/create-application-location-ec.constants";
let CreateApplicationLocationZcamsComponent = class CreateApplicationLocationZcamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    selectedApplicationService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    searchApplicationsService;
    active = 0;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationZcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationZcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationZcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationZcConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationZcConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationZcConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationZcConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationZcConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationZcConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationZcConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationZcConstants.ADDRESS_CONTROL;
    ownerControl = CreateApplicationLocationZcConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationZcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationZcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationZcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationZcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationZcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationZcConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = CreateApplicationLocationZcConstants.OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationZcConstants.REMOVE_PROPERTY_LABEL;
    copyOwnerLabel = CreateApplicationLocationZcConstants.COPY_OWNER_LABEL;
    ownerDisableAdd = false;
    ownerDisableFilterBy = true;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owner";
    ownerShowGroupsDropdown = true;
    applicantGroups = [];
    selectedApplicationLocationZcamsSubscription;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    zcApplication;
    yes = SharedConstants.YES_NO_ENUM.Yes;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, selectedApplicationService, requestStatusService, mapTools, changeDetectorRefs, searchApplicationsService) {
        super(createApplicationService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.selectedApplicationService = selectedApplicationService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            // this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.subscribeToClearMapGraphics();
        this.changeDetectorRefs.detectChanges();
    }
    checkSave() {
        this.selectedApplicationLocationZcamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            this.zcApplication = app;
            if (this.zcApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationZcConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                id: new FormControl(0),
                applicationId: new FormControl(0),
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfNo"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.handleAddProperty(newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationZcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    handleAddProperty(newProperty) {
        const propertyControl = this.getProperties();
        if (this.getProperties().controls.length > 0) {
            this.appController.showMessage("Only one property can be added per application.", AlertType.Warning);
        }
        else {
            propertyControl.push(newProperty);
            this.active = 0;
            this.updateRequiredFields(0);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
        }
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Rates certificate management graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    syncMapExistingGeometries() {
        const propertiesArray = this.getProperties();
        while (propertiesArray.controls.length > 0) {
            propertiesArray.removeAt(0);
        }
        this.zcApplication.properties.forEach((prop) => {
            propertiesArray.push(this.singleFg(prop));
            this.updateRequiredFields(propertiesArray.length - 1);
        });
        if (propertiesArray.length > 0) {
            this.active = 0;
        }
    }
    subscribeToClearMapGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber, [Validators.required]),
            subdivision: new FormControl(prop.subdivision, [Validators.required]),
            allotment: new FormControl(prop.allotment, [Validators.required]),
            farmNo: new FormControl(prop.farmNumber, [Validators.required]),
            sgCode: new FormControl(prop.sgCode, [Validators.required]),
            address: new FormControl(prop.address, [Validators.required]),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geom)
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.zcApplication.properties && this.zcApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                propertyFoemGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.handleServerErrorMessage(CreateApplicationLocationZcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
        return propertyFoemGroup;
    }
    onCopyOwnerToApplicant(propertyIndex) {
        const ownersControl = this.getProperties().controls[propertyIndex].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientService },
        { type: AppControllerService },
        { type: MapService },
        { type: SelectedApplicationService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationZcamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-zcams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationZcamsComponent);
export { CreateApplicationLocationZcamsComponent };
